module.exports = __webpack_public_path__ + "static/media/gri-only-text.8c51ce3f.svg";